import { recentAnnouncements } from "./../../models/organizationModels";
import { organizationMain } from "../../models/organizationModels";
import { OrganizationActionTypes } from "../actions/organizationActions";
import InitialState from "./initialState";

const initialState: organizationMain = InitialState.organization;

const normalizeListPayload = (payload: any, keys: string[] = []) => {
  if (Array.isArray(payload)) return payload;

  const fallbackKeys = [
    "data",
    "rows",
    "organization_list",
    "department_list",
    "designation_list",
    "employee_type_list",
    "employee_timing_list",
  ];

  const candidateKeys = [...fallbackKeys, ...keys];
  for (const key of candidateKeys) {
    if (Array.isArray(payload?.[key])) {
      return payload[key];
    }
  }

  return [];
};

const buildPaginationState = (payload: any, previousPagination?: any) => {
  const pagination = payload?.pagination;
  return {
    pageIndex: pagination?.pageIndex ?? previousPagination?.pageIndex ?? 0,
    pageSize: pagination?.pageSize ?? previousPagination?.pageSize ?? 10,
    total: pagination?.total ?? payload?.total ?? payload?.count ?? 0,
    totalPages:
      pagination?.totalPages ??
      (pagination?.total && pagination?.pageSize
        ? Math.ceil(pagination.total / pagination.pageSize)
        : 0),
  };
};

export default function OrganizationReducer(
  state: organizationMain = initialState,
  action: any,
) {
  switch (action.type) {
    case OrganizationActionTypes.Get_All_Filter_Organization_Success_Action: {
      const payload = action.payload;
      const organizationList = normalizeListPayload(payload);
      const pagination = buildPaginationState(
        payload,
        state.organization_pagination,
      );
      return {
        ...state,
        organization_filter_list: organizationList,
        organization_pagination: pagination,
      };
    }
    case OrganizationActionTypes.Get_All_Department_Success_Action: {
      const departmentPayload = action.payload;
      const normalizedDepartmentList = normalizeListPayload(departmentPayload, [
        "department_list",
      ]);
      return {
        ...state,
        department_list: normalizedDepartmentList,
        department_total_count:
          departmentPayload?.pagination?.total ??
          departmentPayload?.total_count ??
          departmentPayload?.totalCount ??
          departmentPayload?.count ??
          normalizedDepartmentList.length,
        department_pagination: buildPaginationState(
          departmentPayload,
          state.department_pagination,
        ),
      };
    }
    case OrganizationActionTypes.Get_All_Service_List_Success_Action:
      return { ...state, service_list: action.payload };
    case OrganizationActionTypes.Get_All_Designation_Success_Action: {
      const designationPayload = action.payload;
      const designationList = normalizeListPayload(designationPayload, [
        "designation_list",
      ]);
      return {
        ...state,
        designation_list: designationList,
        designation_pagination: buildPaginationState(
          designationPayload,
          state.designation_pagination,
        ),
      };
    }
    case OrganizationActionTypes.Get_All_Employee_Timing_Success_Action: {
      const employeeTimingPayload = action.payload;
      const employeeTimingList = normalizeListPayload(employeeTimingPayload, [
        "employee_timing_list",
      ]);
      return {
        ...state,
        employee_timing_list: employeeTimingList,
        employee_timing_pagination: buildPaginationState(
          employeeTimingPayload,
          state.employee_timing_pagination,
        ),
      };
    }
    case OrganizationActionTypes.Get_All_Employee_Type_Success_Action: {
      const employeeTypePayload = action.payload;
      const employeeTypeList = normalizeListPayload(employeeTypePayload, [
        "employee_type_list",
      ]);
      return {
        ...state,
        employee_type_list: employeeTypeList,
        employee_type_pagination: buildPaginationState(
          employeeTypePayload,
          state.employee_type_pagination,
        ),
      };
    }
    case OrganizationActionTypes.Domain_Get_All_Success_Action:
      return {
        ...state,
        domain_list: action.payload.component_type,
        salary_priod: action.payload.salary_priod,
      };
    case OrganizationActionTypes.Get_All_Salary_Structure_Success_Action:
      return { ...state, salary_structure_list: action.payload };
    case OrganizationActionTypes.Salary_Structure_Edit_Success_Action:
      return {
        ...state,
        salary_structure_edit: action.payload,
      };
    case OrganizationActionTypes.Salary_Component_GetAll_Success_Action:
      return { ...state, component_list: action.payload };
    case OrganizationActionTypes.Get_All_Post_Success_Action:
      return { ...state, post_list: action.payload };
    case OrganizationActionTypes.Salary_Calculation_Load_Success_Action:
      return {
        ...state,
        calculation_type: action.payload.calculation_type,
        operator: action.payload.operator,
        operator_tye: action.payload.operator_tye,
        global_key: action.payload.global_key,
      };
    case OrganizationActionTypes.Get_Main_Dashboard_Success_Action:
      return {
        ...state,
        currentMonthBirthday: action.payload.currentMonthBirthday,
        createEmpOnMonth: action.payload.createEmpOnMonth,
        recentAnnouncements: action.payload.recentAnnouncements,
        holidaysList: action.payload.holidaysList,
        empPresents: action.payload.empPresents,
        unseenNotiCount: action.payload.unseenNotiCount,
      };
    case OrganizationActionTypes.Salary_Component_Threshold_Parameter_Success_Action:
      return {
        ...state,
        salary_compo_threshold: action.payload,
      };

    case OrganizationActionTypes.Domain_Get_Type_Success_Action:
      return {
        ...state,
        domain_list: action.payload.component_type,
        salary_priod: action.payload.salary_priod,
      };
    case OrganizationActionTypes.Domain_Get_Type_User_Success_Action:
      return {
        ...state,
        event_type: action.payload.event_type,
        event_action: action.payload.event_action,
        project_document: action.payload.project_document,
        skills: action.payload.skills,
      };
    case OrganizationActionTypes.Attendance_Platform_Get_Success_Action:
      return {
        ...state,
        attendance_platform_list: action.payload,
      };
    case OrganizationActionTypes.Get_All_Post_List_Success_Action:
      return {
        ...state,
        get_all_post: action.payload,
      };
    case OrganizationActionTypes.Get_All_Comment_List_Success_Action:
      return {
        ...state,
        get_all_post_on_comment: action.payload,
      };
    case OrganizationActionTypes.Get_All_Announcement_List_Success_Action:
      return {
        ...state,
        get_all_announcement: action.payload,
      };
    case OrganizationActionTypes.Get_Employee_Update_Shift_Success_Action:
      return {
        ...state,
        Shift_update: action.payload,
      };
    case OrganizationActionTypes.Get_Organogram_Success_Action:
      return {
        ...state,
        organogram_list: action.payload,
      };
    case OrganizationActionTypes.Get_Org_Chart_Success_Action:
      return {
        ...state,
        org_chart: action.payload,
      };
    case OrganizationActionTypes.Get_Org_Bulk_Status_Success_Action: {
      // console.log("Reducer Payload", action.payload);
      // const sanitizeList = (payload: any): any[] => {
      //   if (!payload) return [];
      //   if (Array.isArray(payload)) return payload;
      //   if (payload.list && Array.isArray(payload.list)) return payload.list;
      //   if (payload.data && Array.isArray(payload.data.list))
      //     return payload.data.list;
      //   if (payload.data && Array.isArray(payload.data)) return payload.data;
      //   if (Array.isArray(payload.rows)) return payload.rows;
      //   return [];
      // };
      // return {
      //   ...state,
      //   org_bulk_status_list: sanitizeList(action.payload),
      //   org_bulk_status_total:
      //     action.payload?.total ??
      //     action.payload?.data?.total ??
      //     (Array.isArray(action.payload) ? action.payload.length : 0),
      // };
      return {
        ...state,
        org_bulk_status_list: action.payload?.data || [],
        org_bulk_status_total: action.payload?.pagination?.total || 0,
      };
    }
    default:
      return state;
  }
}
